import type { Player } from '@dicetechnology/doris-core';

import { DiceReceiverManager } from '../services';

import { throwError } from './throwError';

export const configureUserPreferencesPlugin = async (player: Player): Promise<void> => {
    const USER_PREFERENCES_PLUGIN_NAME = 'user-preferences';

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const { persistTextTrackSelection } = diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    // If the plugin is not yet added, only proceed if persistTextTrackSelection is enabled.
    if (!persistTextTrackSelection && !player.getPluginByName(USER_PREFERENCES_PLUGIN_NAME)) {
        return;
    }

    const { UserPreferencesPlugin } = await import('@dicetechnology/doris-plugin-user-preferences');

    const realm = diceReceiverManager.getRealm();

    const localStorageKey = `user_preferences_${realm}`;

    const existingPlugin = player.getPluginByType(UserPreferencesPlugin);
    if (existingPlugin) {
        existingPlugin.setLocalStorageKey(localStorageKey);
        existingPlugin.setPersistTextTrackSelection(persistTextTrackSelection);
    } else {
        player.addPlugin({
            name: USER_PREFERENCES_PLUGIN_NAME,
            Plugin: UserPreferencesPlugin,
            config: {
                localStorageKey,
                persistTextTrackSelection
            }
        });
    }
};
